import axios from "axios";
import storeApis from "../../api/storeApi";
import Cookies from "js-cookie";
import * as types from "../../constants/MicrositeActionTypes";
import toast from 'react-hot-toast';

export const setMicrositeUnauthorized = (value) => {
    return (dispatch) => {
        dispatch({ type: types.UNAUTHORIZED_MICROSITE, payload: value });
    };
};

export const urlUpdateHandle = (value) => {
    return (dispatch) => {
        dispatch({ type: types.URL_DATA, payload: value });
    };
};

export const saveAuthtoken = (value) => {
    return (dispatch) => {
        dispatch({ type: types.AUTH_TOKEN, payload: value });
    };
};

export const setSystemIp = (value) => {
    return (dispatch) => {
        dispatch({ type: types.SYSTEM_IP, payload: value });
    };
};

export const initializeSolutionData = (value) => {
    return (dispatch) => {
        dispatch({ type: types.FETCH_SOLUTION_TYPE_DATA, payload: value });
    };
};

// Fetch chat history listing

export const fetchMainData = (authToken,url) => {
  return async (dispatch) => {
    try {
      const response = await storeApis.post(
        "framework/api/microsite/spProfileDetails",
        {
          "type":"full_profile",
          "url": url
        },
        {
          headers: {
            Accept: "application/json",
            Vtoken: `${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          return null;
        } else {
          // Dispatch main data
          await dispatch({
            type: types.FETCH_MAIN_DATA,
            payload: response.data.response,
          });
          
          // Dispatch theme data separately
          if (response.data.response?.theme) {
            await dispatch({
              type: types.SET_THEME_COLORS,
              payload: response.data.response.theme
            });
          }
          
          document.title = `Microsite: ${response.data.response?.microsite?.name} | ${response.data.response?.microsite?.client_name}`;
          
          // Return the response data for image preloading
          return response.data.response;
        }
      }
    } catch (err) {
      console.error('Error fetching main data:', err);
      return null;
    //   dispatch({
    //     type: "UNAUTHORIZED_CHAT_AI",
    //     payload: err.response.status,
    //   });
    }
  };
};

export const fetchLeaderDetailData = (authToken, category_id) => {
  return async (dispatch) => {
    try {
      const response = await storeApis.post(
        "/framework/api/microsite/spCategoryDetails",
        {
          cat_id: category_id
        },
        {
          headers: {
            Accept: "application/json",
            Vtoken: `${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
        //   dispatch({
        //     type: "UNAUTHORIZED_CHAT_AI",
        //     payload: response.data.statusCode,
        //   });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          return null;
          // Toast(response.data.message, "E");
        } else {
          await dispatch({
              type: types.FETCH_PROFILE_DATA,
              payload: response.data.response,
            });
            
            // Return the response data for image preloading
            return response.data.response;
        }
      }
    } catch (err) {
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      return null;
    //   dispatch({
    //     type: "UNAUTHORIZED_CHAT_AI",
    //     payload: err.response.status,
    //   });
    }
  };
};

export const submitLeadForm = (authToken, payload, source, flow, onSuccess) => {  
  const formatDateToISD = (dateString) => {
    const date = new Date(dateString);
    const padZero = (num) => (num < 10 ? `0${num}` : num);
    const year = date.getFullYear();
    const month = padZero(date.getMonth() + 1);
    const day = padZero(date.getDate());
    const hours = padZero(date.getHours());
    const minutes = padZero(date.getMinutes());
    const seconds = padZero(date.getSeconds());
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }  
  payload.source = source;
  payload.flow = flow;
  return async (dispatch) => {
    try {
      const response = await storeApis.post(
        "/framework/api/microsite/microSiteLeadForm",
        payload,
        {
          headers: {
            Accept: "application/json",
            Vtoken: `${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
        //   dispatch({
        //     type: "UNAUTHORIZED_CHAT_AI",
        //     payload: response.data.statusCode,
        //   });
          // Toast(response.data.message, "E");
        } else {
            onSuccess();
            let data = Cookies.get("c");
            if (data != response?.data?.contact_id && response?.data?.contact_id != "" ) {
              Cookies.set("c", response?.data?.contact_id);
              // Set current time as start time in cookies
              let current_date = new Date();
              let start_time_new = formatDateToISD(current_date);
              Cookies.set("s_t", start_time_new);
            }
            toast.success(response.data.message)
        }
      }
    } catch (err) {
    //   dispatch({
    //     type: "UNAUTHORIZED_CHAT_AI",
    //     payload: err.response.status,
    //   });
    }
  };
};


export const fetchQualificationData = (authToken) => {   
  return async (dispatch) => {
    try {
      const response = await storeApis.post(
        "/framework/api/microsite/qualifications",
        {},
        {
          headers: {
            Accept: "application/json",
            Vtoken: `${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
        //   dispatch({
        //     type: "UNAUTHORIZED_CHAT_AI",
        //     payload: response.data.statusCode,
        //   });
          // Toast(response.data.message, "E");
        } else {
            dispatch({ type: "QUALIFICATION_DATA", payload: response?.data?.response });
        }
      }
    } catch (err) {
    //   dispatch({ type: "TOGGLE_LOADING", payload: false });
    //   dispatch({
    //     type: "UNAUTHORIZED_CHAT_AI",
    //     payload: err.response.status,
    //   });
    }
  };
};

export const fetchSolutionTypeData = (authToken, id, onSuccess) => {
  return async (dispatch) => {
    try {
      const response = await storeApis.post(
        "framework/api/microsite/spProductList",
        {},
        {
          headers: {
            Accept: "application/json",
            Vtoken: `${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
        //   dispatch({
        //     type: "UNAUTHORIZED_CHAT_AI",
        //     payload: response.data.statusCode,
        //   });
          // Toast(response.data.message, "E");
        } else {
          await dispatch({
              type: types.FETCH_SOLUTION_TYPE_DATA,
              payload: response.data.response,
          });
          if (onSuccess) onSuccess();
        }
      }
    } catch (err) {
    //   dispatch({ type: "TOGGLE_LOADING", payload: false });
    //   dispatch({
    //     type: "UNAUTHORIZED_CHAT_AI",
    //     payload: err.response.status,
    //   });
    }
  };
};

// Fetch tracking details when trd is present in URL
export const fetchTrackingDetails = (trd) => {
  return async (dispatch) => {
    try {
      const response = await storeApis.post(
        "framework/api/trackingDetails",
        { trd },
        {
          headers: {
            Accept: "application/json",
          },
        }
      );
      if (response.status === 200) {
        dispatch({ type: types.TRACKING_DETAILS, payload: response.data.tracking_details });
      } else {
        dispatch({ type: types.TRACKING_DETAILS, payload: null });
      }
    } catch (err) {
      dispatch({ type: types.TRACKING_DETAILS, payload: null });
    }
  };
};

// event tracking

export const eventTracking = (authToken, recaptchaToken, url, action, end_time, flow, contact_id) => {
  
  const formatDateToISD = (dateString) => {
    const date = new Date(dateString);
    const padZero = (num) => (num < 10 ? `0${num}` : num);
    const year = date.getFullYear();
    const month = padZero(date.getMonth() + 1);
    const day = padZero(date.getDate());
    const hours = padZero(date.getHours());
    const minutes = padZero(date.getMinutes());
    const seconds = padZero(date.getSeconds());
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  const getTimeDifferenceInMinutes = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);
    return Math.floor((end - start) / (1000 * 60)); // Convert milliseconds to minutes
  }
  
  return async (dispatch) => {
    let current_date = new Date();
    let start_time_new = formatDateToISD(current_date);
    let cookie_time = Cookies.get("s_t");
    const idleTimeInMinutes = action === "idle" ? 10 : 0; // 600 seconds = 10 minutes

    // Check time difference if cookie exists
    if (cookie_time) {
      const timeDiff = getTimeDifferenceInMinutes(cookie_time, current_date);
      const effectiveTime = timeDiff - idleTimeInMinutes; // Subtract idle time from total interval

      // If effective time is more than 5 minutes, update the start time
      if (effectiveTime > 5) {
        cookie_time = start_time_new; // Update the reference time
        Cookies.set("s_t", start_time_new);
      }
    }

    // Handle different actions
    if (action === "end") {
      Cookies.remove("s_t");
      Cookies.set("s_t", start_time_new);
    } else if (action === "idle") {
      Cookies.remove("s_t");
    } else if (action === "start") {
      if (!Cookies.get("s_t")) {
        Cookies.set("s_t", start_time_new);
      }
    } else {
      console.log("calling in 20 seconds");
    }

    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.post(
        "/framework/api/microsite/event-action",
        {
            recaptcha_token: recaptchaToken,
            url: url,
            start: (action === "end" || action === "idle") ? cookie_time : Cookies.get("s_t"),
            end: end_time,
            idle: action == "idle" ? 600 : 0, // Pass idle time in seconds to API
            visit_page: flow,
            c: contact_id,
        },
        {
          headers: {
            Accept: "application/json",
            Vtoken: `${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
        //   dispatch({
        //     type: "UNAUTHORIZED_CHAT_AI",
        //     payload: response.data.statusCode,
        //   });
        //   dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
    //   dispatch({ type: "TOGGLE_LOADING", payload: false });
    //   dispatch({
    //     type: "UNAUTHORIZED_CHAT_AI",
    //     payload: err.response.status,
    //   });
    }
  };
};